<template>
  <Modal
    @close="$emit('close')"
    padding="32px 59px"
    height="734px"
    width="687px"
  >
    <PageName title="Электронные билеты"/>
    <div class="scroll">
      <div
          class="ticket"
          v-for="(ticket, i) in tickets"
          :key="i"
      >
        <span>{{ticket.file_name}}</span>
        <Button
            text = "Скачать"
            icon = "download"
            class="buttons__item"
            iconWidth="20px"
            @click="download(ticket)"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modals/Modal.vue"
import PageName from "@/components/PageName.vue"
import Button from "@/components/Button"
import {getBase64} from "@/api/files";

export default {
  name: "TicketsModal",
  components: {
    Modal,
    PageName,
    Button,
  },
  props: {
    tickets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ticketsLoading: new Array(this.tickets.length).fill(true),
    };
  },
  methods: {
    loaded(index) {
      this.$set(this.ticketsLoading, index, false);
    },
    async download(ticket) {
      const res = await getBase64(ticket.id)
      let a = document.createElement("a");
      a.href = res.data
      a.download = ticket.file_name
      a.click()
      a.remove()
    }
  },
};
</script>

<style scoped lang="scss">
.ticket {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
}
.buttons__item {
  color: #0078d2;
  font-size: 16px;
}
.buttons__item:hover {
  color: #008efa;
  fill: #008efa;
}
</style>
